import styled from 'styled-components'
import theme from 'styles/theme'

const Label = styled.label`
  color: ${theme.colors.black};
  font-size: 16px;
`

export { Label }
